import { render } from "./Kar.vue?vue&type=template&id=c08d7ee4"
import script from "./Kar.vue?vue&type=script&lang=js"
export * from "./Kar.vue?vue&type=script&lang=js"

import "./Kar.vue?vue&type=style&index=0&id=c08d7ee4&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__